export default "__VITE_ASSET__ecbd7763__"